import React from "react";

export default class MicSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = { devices: [] };
  }

  componentDidMount() {
    this.enumerate();
    try {
      if (navigator?.mediaDevices?.addEventListener) {
        navigator.mediaDevices.addEventListener('devicechange', this.enumerate);
      }
    } catch (_) {}
  }

  componentWillUnmount() {
    try {
      if (navigator?.mediaDevices?.removeEventListener) {
        navigator.mediaDevices.removeEventListener('devicechange', this.enumerate);
      }
    } catch (_) {}
  }

  enumerate = async () => {
    try {
      // Light permission probe to ensure labels are available
      try {
        await navigator.mediaDevices.getUserMedia({ audio: true });
      } catch (_) {}
      const all = await navigator.mediaDevices.enumerateDevices();
      const devices = all.filter(d => d.kind === 'audioinput');
      this.setState({ devices });

      const { value, onChange } = this.props;
      const hasValue = value && devices.some(d => d.deviceId === value);
      if (!hasValue) {
        const firstId = devices[0]?.deviceId || '';
        if (firstId && typeof onChange === 'function') onChange(firstId);
      }
    } catch (_) {}
  }

  render() {
    const { value = "", onChange, className = "", style } = this.props;
    const devices = this.state.devices || [];
    return (
      <div className={className} style={{ display: 'flex', alignItems: 'center', gap: 12, ...(style || {}) }}>
        <label htmlFor="lrp-mic" style={{ fontSize: 16, opacity: .9 }}>Mic</label>
        <select
          id="lrp-mic"
          className="lrp-select"
          value={value}
          onChange={(e) => onChange && onChange(e.target.value)}
        >
          {devices.map((d, idx) => (
            <option key={d.deviceId || idx} value={d.deviceId}>
              {d.label || `Mic ${idx + 1}`}
            </option>
          ))}
        </select>
      </div>
    );
  }
}
